
import React from "react";
import ContactsSection from "../../components/section/contacts_section";
import WelcomeSection from "../../components/section/welcome_section";
import ServicesSection from "../../components/section/services_section";
import MobileAppSection from "../../components/section/mobile_app_section";
import BrandsSection from "../../components/section/brands";

function HomePage(){
    return <div id={'home-page'} className={'text-center'}>

        <WelcomeSection />

        {/*<BrandsSection />*/}

        {/*<ServicesSection />*/}

        {/*<MobileAppSection />*/}

        {/*<ContactsSection />*/}
    </div>
}

export default HomePage;